export const CircleNotCheckRed = (): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    fill="none"
    viewBox="0 0 14 14"
  >
    <g>
      <path
        stroke="red"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M8.8 5.2L5.2 8.8m0-3.6l3.6 3.6M13 7A6 6 0 111 7a6 6 0 0112 0z"
      />
    </g>
  </svg>
);
